
<mat-dialog-content>
  <h2 mat-dialog-title *ngIf="isMSMEData() || isIAData()">Event Data</h2>
  <!-- MSME Table -->
  <div *ngIf="isMSMEData()">
    <table class="table table-striped table-bordered table-hover" style="width: 100%; height: 100%;">
      <thead>
        <tr>
          <th>Event ID</th>
          <th>Event Name</th>
          <th>Interest Name</th>
          <th>Organisation</th>
          <th>Event Date</th>
          <th>Event Time</th>
          <th>Venue</th>
          <!--<th>Status</th>-->
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data">
          <td>{{ item.EventId }}</td>
          <td>{{ item.EventName }}</td>
          <td>{{ item.InterestName }}</td>
          <td>{{ item.NameOfOrganisation }}</td>
          <td>{{ item.EventDate }}</td>
          <td>{{ item.Time }}</td>
          <td>{{ item.VenueDetails }}</td>
          <!--<td>{{ item.EventStatus }}</td>-->           
        <td>
          <ng-container *ngIf="isBeforeToday(item.EventDate)">
            <button (click)="ViewEventDetails(item.EventId)" class="btn btn-primary btn-sm me-2 mt-1">
              <i class="bi bi-eye"></i>
              View
            </button>
          </ng-container>
          <ng-container *ngIf="item.EventStatus === 'completed' && item.AttendedCount>0">
            <div>
              <button (click)="SubmitFeedback(item.EventId)" class="btn btn-info btn-sm mt-1">
                <i class="bi bi-chat-dots"></i>
                {{ item.SubmittedFeedback > 0? 'Feedback & Certificate':'Submit Feedback'}}
              </button>
            </div>
          </ng-container>
          <!--<ng-container *ngIf="item.EventStatus === 'completed' && item.AttendedCount>0">
            <div>
              <button (click)="SubmitFeedback(item.EventId)" class="btn btn-info btn-sm mt-1">
                <i class="bi bi-chat-dots"></i>
                Submit Feedback
              </button>
            </div>
          </ng-container>-->
          <!--<ng-container *ngIf="item.EventStatus === 'completed' && item.AttendedCount > 0 && item.SubmittedFeedback > 0">
    <div>
      <button (click)="downloadMSMECertificate(item.eventId,item.enrollmentId)" class="btn btn-info btn-sm mt-1">
        <i class="bi bi-chat-dots"></i>
        Download Certificate
      </button>
    </div>
  </ng-container>-->
          <ng-container *ngIf="isToday(item.EventDate)">
            <button (click)="ViewEventDetails(item.EventId)" class="btn btn-primary btn-sm me-2 mt-1">
              <i class="bi bi-eye"></i>
              View
            </button>
            <div *ngIf="item.Enrolled > 0">
              <button (click)="DownloadTicket(item.EventId)" class="btn btn-warning btn-sm me-2 mt-1">
                <i class="bi bi-download"></i>
                Download Ticket
              </button>
            </div>
          </ng-container>

          <ng-container *ngIf="isTomorrowOrFuture(item.EventDate, item.Time)">
            <button (click)="ViewEventDetails(item.EventId)" class="btn btn-primary btn-sm me-2 mt-1">
              <i class="bi bi-eye"></i>
              View
            </button>
            <div>
              <button (click)="EnrollEvent(item.EventId)" class="btn btn-success btn-sm me-2 mt-1" *ngIf="!isEventWithin24Hours(item.EventDate, item.Time)">
                <i class="bi bi-check-circle"></i>
                {{ item.Enrolled > 0 ? 'Edit/Enroll' : 'Enroll' }}
              </button>
            </div>
            <div *ngIf="item.Enrolled > 0">
              <button (click)="DownloadTicket(item.EventId)" class="btn btn-warning btn-sm me-2 mt-1">
                <i class="bi bi-download"></i>
                Download Ticket
              </button>
            </div>
          </ng-container>
        </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- IA Table -->
  <div *ngIf="isIAData()">
    <h3>IA Events</h3>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Sr.No</th>
          <th>Event Name</th>
          <th>Component Name</th>
          <th>Event Date</th>
          <th>Event Time</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data">
          <td>{{ item.SerialNumber }}</td>
          <td>{{ item.eventname }}</td>
          <td>{{ item.ComponentName }}</td>
          <td>{{ item.EventDate }}</td>
          <td>{{ item.time }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <h2 mat-dialog-title *ngIf="isMSMEParticipantsData()">Participants</h2>
  <div *ngIf="isMSMEParticipantsData()">    
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>EnrollmentID</th>
          <th>Participant Name</th>
          <th>Mobile</th>
          <th>UdyamNumber</th>
          <th>Feedback Submitted</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data">
          <!--<td class="text-primary no-underline" style="cursor: pointer;" (click)="SubmitParticipantFeedback(item.eventId,item.enrollmentId)">{{ item.enrollmentId }}</td>-->
          <td [ngClass]="{ 'text-primary no-underline': item.enrollmentId }"
              [style.cursor]="item.enrollmentId ? 'pointer' : 'default'"
              (click)="item.enrollmentId && SubmitParticipantFeedback(item.eventId, item.enrollmentId)">
            {{ item.enrollmentId || '' }}
          </td>         
          <td>{{ item.participantName }}</td>
          <td>{{ item.participantMobile }}</td>
          <td>{{ item.udyamRegistrationNumber }}</td>
          <td>
            <button *ngIf="item.feedbackSubmitted" class="btn btn-info btn-sm mt-1" (click)="downloadMSMECertificate(item.eventId,item.enrollmentId)">
              <i class="bi bi-chat-dots"></i>
              Download Certificate
            </button>
            <span *ngIf="!item.feedbackSubmitted">No</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
